var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLuggageIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17.344,
    viewBox: "0 0 12 17.344",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.041 -293.294)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.041 293.294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.24 1.057A1.842 1.842 0 0 0 .394 2.9v9.231A1.842 1.842 0 0 0 2.24 13.98v1.042a.278.278 0 0 0 .278.278h1.291a.278.278 0 0 0 .278-.278V13.98H8.7v1.042a.278.278 0 0 0 .278.278h1.292a.278.278 0 0 0 .278-.278V13.98a1.842 1.842 0 0 0 1.846-1.846V2.9a1.842 1.842 0 0 0-1.846-1.846zm2.586 2.437h3.137a.278.278 0 0 1 .278.278v1.292a.276.276 0 0 1-.278.276H4.826a.276.276 0 0 1-.278-.276V3.772a.278.278 0 0 1 .278-.278z",
    className: "cls-1",
    transform: "translate(-.394 2.044)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.915.394a.83.83 0 0 0-.831.831v1.347h1.385V2.2a.415.415 0 0 1 .415-.416h1.94a.415.415 0 0 1 .415.416v.377h1.384V1.225a.83.83 0 0 0-.831-.831z",
    className: "cls-1",
    transform: "translate(2.146 -.394)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLuggageIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/luggage-icon.0b1d3624.svg";
export { ForwardRef as ReactComponent };